// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Ryv59","table":"styles_table__irHOR","desc":"styles_desc__Fcq6U"};